/* eslint-disable node/no-unsupported-features/es-syntax */
import { LANGUAGES_ROUTE_NAMES } from "@/shared";

export const LANGUAGES_ROUTES = [
    {
        name: LANGUAGES_ROUTE_NAMES.LIST,
        path: "/languages",
        meta: {
            title: "Языки",
        },
        component: () => import("../ui/LanguagesList.vue"),
    },
    {
        name: LANGUAGES_ROUTE_NAMES.CREATE,
        path: "/languages/add",
        meta: {
            title: "Новый Язык",
        },
        component: () => import("../ui/LanguagesEdit.vue"),
    },
    {
        name: LANGUAGES_ROUTE_NAMES.EDIT,
        path: "/languages/:id",
        meta: {
            title: "Редактирование Языка",
        },
        component: () => import("../ui/LanguagesEdit.vue"),
        props: true,
    },
];
